import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectOverviewComponent } from './project-overview.component';
import { ProjectOverviewViewComponent } from './project-overview-view/project-overview-view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StatusCircleModule } from '../shared/status-circle/status-circle.module';
import { UserAssignmentModule } from '../shared/user-assignment/user-assignment.module';
import { FilterBarModule } from '../shared/filter-bar/filter-bar.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { UserManualDirective } from '../shared/user-manual/user-manual.directive';

@NgModule({
  declarations: [ProjectOverviewComponent, ProjectOverviewViewComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StatusCircleModule,
    UserAssignmentModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    FilterBarModule,
    UserManualDirective,
  ],
})
export class ProjectOverviewModule {}
